







import { BPopover } from 'bootstrap-vue';
import Vue from 'vue';
import { mixins } from 'vue-class-component';

import { Component, Prop } from 'vue-property-decorator';
@Component({
  name: 'bpc-prop-popover',
  components: {},
})
export default class PropPopover extends mixins(BPopover) {
  @Prop({ type: String }) readonly titleHtml: string;
  @Prop({ type: String }) readonly bodyHtml: string;
}
